import FormularioCampanha from "../../../components/Forms/Campanha/FormularioCampanha";
import HeaderLateral from "../../../components/HeaderLateral";
import { Helmet } from 'react-helmet';

export default function FormularioCampanhas(){
    return (
        <div className="solicitarcontainer">
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Campanhas</title>
            </Helmet>
            <HeaderLateral />
            <FormularioCampanha />
        </div>
    )
}